<template>
  <v-card>
    <v-card-text>
      <v-radio-group class="mt-0" v-model="selectedPlan" column>
        <v-radio          
          :value="plan"
          :key="index"
          v-for="(plan, index) in plans"
        >
          <template v-slot:label>
            <div>
              <div class="title">{{ plan.name }}</div>
              <div>{{ plan.price }}</div>
              <div class="font-weight-medium">{{ plan.highlight }}</div>
              <div>{{ plan.description }}</div>
              <small v-if="plan.smallPrint">{{ plan.smallPrint }}</small>
            </div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-card-text>
    <div class="text-center red--text"><span>You will not be charged today.</span></div>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn large text @click="step = step - 1">Back</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="nextWindow" color="primary" large>next</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

const plans = [
  {
    id: "software",
    name: "Software Plan",
    price: "$0.50 per child per month",
    monthlyPricePerChild: 0.5,
    highlight: "First year free",
    description: "Run your school yourself with the full Taleem software.",
    smallPrint: "Free for 12 months, then $0.50 per child per month.",
    firstYearFree: true,
  },
  {
    id: "software-support",
    name: "Software + Support Plan",
    price: "$3 per child per month",
    monthlyPricePerChild: 3,
    highlight: "We do the follow-up for you",
    description: "Everything in the Software plan, plus our team sets everything up for you, contacts parents on your behalf, and helps you collect tuition and fees.",
    firstYearFree: false,
  },
];

export default {
  data() {
    return {
      selectedPlan: plans[0],
      plans,
    };
  },
  computed: {
    ...mapGetters("auth", ["getStep"]),
    emailErrors() {
      const errors = [];
      if (!this.$v.Business.email.$dirty) return errors;
      if (!this.$v.Business.email) errors.push("Email is not valid");
      if (!this.$v.Business.email.required) errors.push("Email is required.");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.Business.name.$dirty) return errors;
      if (!this.$v.Business.name.minLength)
        errors.push("Field must be at least 5 characters long");
      if (!this.$v.Business.name.required)
        errors.push("Business Name is required.");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.Business.phoneNumber.$dirty) return errors;
      if (!this.$v.Business.phoneNumber.required)
        errors.push("Phone Number is required.");
      return errors;
    },
    step: {
      get: function() {
        return this.getStep;
      },
      set: function(val) {
        this.setStep(val);
      },
    },
  },
  methods: {
    ...mapActions("auth", ["setStep"]),    
    nextWindow() {
      if (!this.selectedPlan) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: true,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: "Select plan you like to try",
          });
      } else {
        this.$emit("submit", this.selectedPlan);
        this.step = 4;
      }
    },
  },
};
</script>

<style scoped></style>
